/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MinusIcon16Light = forwardRef('MinusIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.91 7.5a.5.5 0 0 1 .5-.5h10.18a.5.5 0 0 1 0 1H2.41a.5.5 0 0 1-.5-.5Z" })));
});
